import * as React from "react";
const SvgFiRrChessPiece = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chess-piece_svg__a)">
      <path
        fill="#062147"
        d="M20.025 22.026h-1V20.37A4.01 4.01 0 0 0 17.8 17.5c-1.924-1.86-2.709-3.99-2.766-7.476h.988a1 1 0 1 0 0-2h-.556a3.95 3.95 0 0 0 .556-2c0-1.375-1.162-3.717-1.893-4.87a2.5 2.5 0 0 0-4.212 0c-.732 1.154-1.894 3.5-1.894 4.87.005.705.196 1.396.556 2h-.553a1 1 0 0 0 0 2h.99c-.059 3.488-.845 5.617-2.767 7.476a4.02 4.02 0 0 0-1.223 2.87v1.655h-1a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2m-8.417-19.8a.5.5 0 0 1 .835 0 10.8 10.8 0 0 1 1.582 3.8 2 2 0 1 1-4 0 10.8 10.8 0 0 1 1.583-3.8m1.43 7.8c.054 3.516.8 5.95 2.522 8H8.491c1.72-2.05 2.468-4.485 2.523-8zM7.026 20.37q.003-.174.036-.345h9.928q.033.171.035.345v1.655h-10z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chess-piece_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChessPiece;
